import { useCallback, useMemo, useState, useEffect } from 'react';
export function useOnChildrenRendered(_a) {
    var _b = _a.componentList, componentList = _b === void 0 ? [] : _b, _c = _a.onAllChildrenRendered, onAllChildrenRendered = _c === void 0 ? undefined : _c;
    var _d = useState(false), areAllChildrenRendered = _d[0], setAreAllChildrenRendered = _d[1];
    var renderedItems = new Set();
    if (onAllChildrenRendered === undefined) {
        return { onItemRendered: function () { return function () { }; } };
    }
    var onItemRendered = useCallback(function (index, onRenderedCb) {
        return useMemo(function () { return function () {
            if (!renderedItems.has(index)) {
                renderedItems.add(index);
            }
            if (renderedItems.size === componentList.length) {
                setAreAllChildrenRendered(true);
            }
            if (onRenderedCb && typeof onRenderedCb === 'function') {
                onRenderedCb();
            }
        }; }, [index]);
    }, []);
    useEffect(function () {
        if (componentList.length === 0) {
            setAreAllChildrenRendered(true);
        }
    }, [componentList.length]);
    useEffect(function () {
        if (!areAllChildrenRendered)
            return;
        onAllChildrenRendered();
    }, [areAllChildrenRendered]);
    return { onItemRendered: onItemRendered, areAllChildrenRendered: areAllChildrenRendered };
}
